export const SAVE_ALL_SHARED_SERVICE_PASSENGERS = 'SAVE_ALL_SHARED_SERVICE_PASSENGERS'